import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import ClickableTooltip from '../../../../ClickableTooltip';
import { Ready } from '../../Types';
import TooltippedTitle from '../TooltippedTitle';
import InfoText from './InfoText';
import LicenseUsageOverview from './LicenseUsageOverview';

interface Props {
  state: Ready;
}

function LicenseUsageOverviews({ state }: Props) {
  return (
    <div className="pt-10">
      <TooltippedTitle title="License Usage Overview">
        <T kind="View the up to date status for all licenses..." />
      </TooltippedTitle>
      <div className={clsx('mb-2 rounded-md bg-white px-8 py-10 drop-shadow-md')}>
        <table className="table-auto w-full">
          <thead>
            <tr>
              <th className="font-medium text-left">
                <T kind="Product" />
              </th>
              <th>
                <ClickableTooltip
                  className="w-full text-right"
                  tooltipIcon={<InfoText text="Activated" />}
                  tooltipId="activated"
                >
                  <div className="text-left font-normal flex flex-col gap-2">
                    <p>
                      <T kind="A license is considered Activated when a..." />
                    </p>
                    <p>
                      <T kind="Activations are restricted when the number of..." />
                    </p>
                  </div>
                </ClickableTooltip>
              </th>
              <th>
                <ClickableTooltip
                  className="w-full text-right"
                  tooltipIcon={<InfoText text="Allocated" />}
                  tooltipId="allocated"
                >
                  <div className="text-left font-normal flex flex-col gap-2">
                    <p>
                      <T kind="A license is considered Allocated when a..." />
                    </p>
                    <p>
                      <T kind="Allocations are not restricted and may exceed..." />
                    </p>
                  </div>
                </ClickableTooltip>
              </th>
              <th className="font-medium text-left pl-8">
                <T kind="Usage Details" />
              </th>
            </tr>
          </thead>
          <tbody>
            {state.resource.payload.productLicenseOverviews.map((l, index) => {
              return <LicenseUsageOverview key={l.id} license={l} index={index} />;
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default observer(LicenseUsageOverviews);
